import React from 'react';
import { NavLink } from 'react-router-dom';
import Icon from '@/components/Icon';
import { useAuth } from '@/auth/AuthContext';

/**
 * Боковое меню личного кабинета учителя. Используем те же CSS-классы,
 * что и админский Sidebar (.sidebar*) — тема, отступы и шрифты совпадают.
 * Состав меню узкий: пока «Расписание». По мере роста ЛК сюда добавятся
 * «Журнал» (свои предметы), «Мой класс» и т.п.
 */
const SECTIONS = [
  {
    title: 'Обучение',
    items: [
      { id: 'schedule',        label: 'Расписание',             icon: 'calendar', to: '/teacher/schedule' },
      { id: 'journal',         label: 'Электронный дневник',    icon: 'book',     to: '/teacher/journal' },
      { id: 'extracurricular', label: 'Внеурочные занятия',     icon: 'sparkle',  to: '/teacher/extracurricular' },
      { id: 'extra',           label: 'Доп. занятия',           icon: 'graduation', to: '/teacher/extra' },
    ],
  },
  {
    title: 'Разное',
    items: [
      { id: 'reports',         label: 'Отчёты',                 icon: 'chart',    to: '/teacher/reports' },
    ],
  },
];

const ROLE_RU = {
  administrator: 'Администратор',
  teacher: 'Учитель',
  parent: 'Родитель',
  expert: 'Эксперт',
};

function initialsOf(name) {
  if (!name) return '?';
  return name.trim().split(/\s+/).slice(0, 2).map((w) => w[0] || '').join('').toUpperCase();
}

export default function TeacherSidebar({ compact }) {
  const { user, logout } = useAuth();
  return (
    <aside className={'sidebar' + (compact ? ' sidebar--compact' : '')}>
      <div className="sidebar__brand">
        <div className="sidebar__logo">
          <img src="/img/logo_navbar.png" alt="" className="sidebar__logoImg" />
        </div>
        {!compact && (
          <div className="sidebar__brandText">
            <div className="sidebar__brandName">Новое Поколение</div>
            <div className="sidebar__brandMeta">кабинет учителя</div>
          </div>
        )}
      </div>

      <nav className="sidebar__nav">
        {SECTIONS.map((sec) => (
          <div key={sec.title} className="sidebar__section">
            {!compact && <div className="sidebar__sectionTitle">{sec.title}</div>}
            {sec.items.map((it) => (
              <NavLink
                key={it.id}
                to={it.to}
                className={({ isActive }) => 'sidebar__item' + (isActive ? ' is-active' : '')}
                title={compact ? it.label : undefined}
              >
                <span className="sidebar__itemIcon"><Icon name={it.icon} size={15} /></span>
                {!compact && <span className="sidebar__itemLabel">{it.label}</span>}
              </NavLink>
            ))}
          </div>
        ))}
      </nav>

      <div className="sidebar__foot">
        <div className="sidebar__user" role="button">
          <div className="sidebar__avatar">{initialsOf(user?.name)}</div>
          {!compact && (
            <div className="sidebar__userText">
              <div className="sidebar__userName">{user?.name || '—'}</div>
              <div className="sidebar__userRole">{ROLE_RU[user?.role] || user?.role}</div>
            </div>
          )}
          {!compact && (
            <button
              className="sidebar__userMore"
              title="Выйти"
              onClick={(e) => { e.stopPropagation(); logout(); }}
            >
              <Icon name="x" size={14} />
            </button>
          )}
        </div>
      </div>
    </aside>
  );
}
